// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSLabelValueList/ABSLabelValueVertical.less
// module id = 785
// module chunks = 42